import React from "react";
import { useSelector } from "react-redux";

export default function Profile() {
  const me = useSelector((s) => s.session?.me);
  const accessToken = useSelector((s) => s.session?.accessToken);

  return (
    <div style={{ padding: 16 }}>
      <h1>Profile</h1>

      <p>Email: <b>{me?.email ?? "Me yükleniyor / boş"}</b></p>
      <p>Status: <b>{useSelector((s) => s.session?.status) ?? "-"}</b></p>
      <p>Token var mı? <b>{accessToken ? "EVET " : "HAYIR "}</b></p>
    </div>
  );
}
